<!-- eslint-disable -->
<template>
  <div v-show="C_isVisible" class="panel-container" :class="P_activeBreakPoint">
    <div class="wrap">
      <div 
        class="quart"
        @mousedown="eventMouseDown(P_buttonUpId, P_buttonUpMakeSingleEvent)"
        @mouseup="eventMouseRelease(P_buttonUpId, P_buttonUpMakeSingleEvent)"
        @click="eventMouseClick(P_buttonUpId, P_buttonUpMakeSingleEvent)"
      >
        <span :class="P_activeBreakPoint" class="quart-dot"></span>
      </div>
      <div 
        class="quart"
        @mousedown="eventMouseDown(P_buttonRightId, P_buttonRightMakeSingleEvent)"
        @mouseup="eventMouseRelease(P_buttonRightId, P_buttonRightMakeSingleEvent)"
        @click="eventMouseClick(P_buttonRightId, P_buttonRightMakeSingleEvent)"
      >
        <span :class="P_activeBreakPoint" class="quart-dot"></span>
      </div>
      <div 
        class="quart"
        @mousedown="eventMouseDown(P_buttonLeftId, P_buttonLeftMakeSingleEvent)"
        @mouseup="eventMouseRelease(P_buttonLeftId, P_buttonLeftMakeSingleEvent)"
        @click="eventMouseClick(P_buttonLeftId, P_buttonLeftMakeSingleEvent)"
      >
        <span :class="P_activeBreakPoint" class="quart-dot"></span>
      </div>
      <div 
        class="quart"
        @mousedown="eventMouseDown(P_buttonDownId, P_buttonDownMakeSingleEvent)"
        @mouseup="eventMouseRelease(P_buttonDownId, P_buttonDownMakeSingleEvent)"
        @click="eventMouseClick(P_buttonDownId, P_buttonDownMakeSingleEvent)"
      >
        <span :class="P_activeBreakPoint" class="quart-dot"></span>
      </div>
      <div class="center">
        <a 
          class="panel-button panel-button-home"
          @mousedown="eventMouseDown(P_buttonHomeId, P_buttonHomeMakeSingleEvent)"
          @mouseup="eventMouseRelease(P_buttonHomeId, P_buttonHomeMakeSingleEvent)"
          @click="eventMouseClick(P_buttonHomeId, P_buttonHomeMakeSingleEvent)"
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { bi10GridComponent } from "../../../watchdog_includes/base_i10_UI_mixins"

export default {
  props: [
    'P_activeBreakPoint',
    'P_buttonHomeId',
    'P_buttonHomeMakeSingleEvent',
    'P_buttonUpId',
    'P_buttonUpMakeSingleEvent',
    'P_buttonRightId',
    'P_buttonRightMakeSingleEvent',
    'P_buttonDownId',
    'P_buttonDownMakeSingleEvent',
    'P_buttonLeftId',
    'P_buttonLeftMakeSingleEvent',
  ],
  mixins: [bi10GridComponent]
}
</script>

<style lang="less" scoped>
.panel-container {
  border-radius: 50%;
  background: black;
  padding: 20px;
  height: 100%;
  width: 100%;
  box-shadow: 0 0 13px 3px #a5a2a2 inset;
  &.sm {
    padding: 10px;
    box-shadow: 0 0 6px 3px #a5a2a2 inset;
  }
}

.panel-button-home {
  display: block;
  height: 50%;
  width: 50%;
  top: 25%;
  right: 25%;
  position: absolute;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(/dynamic/images/b1/NU_GUI/black.png);
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  box-shadow: 0 0 1px 1px #5f5f5f;
  border-radius: 50%;
  &:active {
    background-image: url(/dynamic/images/b1/NU_GUI/blue.png);
  }
}

.wrap {
  height: 100%;
  width: 100%;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  transform: rotate(45deg);
}
.quart {
  color: red;
  position: absolute;
  height: 50%;
  width: 50%;
  background: black;
  box-shadow: 0 0 13px 3px #5f5f5f inset;
}
.quart-dot {
  position: absolute;
  width: 10px;
  height: 10px;
  background: gray;
  border-radius: 50%;
}
.quart:first-child {
  top: 0;
  left: 0;
  height: 47%;
  width: 47%;
  .quart-dot {
    right: 53%;
    top: 35%;
  }
}
.quart:nth-child(2) {
  top: 0;
  left: 58%;
  height: 45%;
  .quart-dot {
    top: 40%;
    left: 50%;
  }
}
.quart:nth-child(3) {
  top: 58%;
  left: 0;
  width: 45%;
  .quart-dot {
    top: 47%;
    left: 40%;
  }
}
.quart:nth-child(4) {
  top: 55%;
  left: 55%;
  .quart-dot {
    top: 50%;
    &.sm {
      top: 45%;
    }
  }
}
.center {
  height: 80%;
  width: 80%;
  position: absolute;
  top: 10%;
  left: 10%;
  background: black;
  border-radius: 50%;
  text-align: center;
  line-height: 160px;
  box-shadow: 0 0 10px 1px #5f5f5f inset;
}
.quart:active {
  background: #93bac7;
  box-shadow: none;
}

@media (max-width: 500px) {
  .panel-container {
    padding: 10px;
    box-shadow: 0 0 6px 3px #a5a2a2 inset;
  }
  .quart:nth-child(4) {
    .quart-dot {
      top: 45%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Grid/crestron/GCameraControl.vue